module.exports = __webpack_public_path__ + "4352be4c83c27f8461c3a40c65ed9aaa.svg";